<template lang="html">
    <div id="TutoringAnalysis"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div style="width: 100%;height: 100%;">
            <el-row style="height: 40px;line-height: 40px;margin-top: 20px">
                <el-col :span="6">
                    <span>月份</span>
<!--                    <el-date-picker-->
<!--                            v-model="date"-->
<!--                            style="width: 150px"-->
<!--                            format="yyyy年MM月"-->
<!--                            value-format="yyyy-MM"-->
<!--                            type="month"-->
<!--                            placeholder="选择月">-->
<!--                    </el-date-picker>-->
                    <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
                </el-col>
                <el-col :span="8">
                    <span>协访评估表</span>
                    <el-select v-model="form_id" style="width:70%" placeholder="请选择协访评估表">
                        <el-option
                                v-for="item in assessmentForm"
                                :key="item.form_id"
                                :label="item.title"
                                :value="item.form_id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="10" v-if="isManager">
                    <div style="float: right">
                        <span style="font-size: 16px;font-weight: bold;margin-right: 10px;">辖区</span>
                        <popedom :handleSelectInput="handleSelectInputClick" :shelfData="shelfData"></popedom>
                    </div>
                </el-col>
            </el-row>

            <el-row style="margin-top:20px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                <el-button size="small" style="background: #4EC880;border:none;color: #fff" @click.stop="searchWeekList">查询</el-button>
                <el-button size="small" style="background: #D0021B;border:none;color: #fff" @click.stop="ResetClick">重置</el-button>
                <el-button size="small" style="float: right;background: #4A90E2;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportDataClick">
                    导出数据
                </el-button>
                <el-button size="small" style="float: right;background: #FF9901;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportDetailClick">
                    导出明细
                </el-button>
            </el-row>
            <el-row>
                <el-col>
                    <p style="font-size: 21px;color: #000;margin-bottom: 5px">{{yearsDate}}</p>
                </el-col>
            </el-row>


            <el-row v-if="!isManager">
                <el-col :span="11" style="margin-top:40px">
                    <el-col :span="6">
                        <p style="font-size: 14px;color: #909399;margin:0;margin-top:35px;">计划协访数</p>
                        <p style="font-size: 14px;color: #909399;margin:0;margin-top:25px">计划完成数</p>
                    </el-col>
                    <el-col :span="10">
                        <p style="width: calc(100% - 50px);display: inline-block;margin:0;margin-top:30px;">
                                <el-progress :text-inside="true" :show-text="false" color="#5B8FF9" stroke-linecap="butt" :stroke-width="20" :percentage="plansProgress"></el-progress>
                        </p>
                        <span style="color:#FF9901;float: right;margin-top:30px;">{{plans}}次</span>
                        <p style="width: calc(100% - 50px);display: inline-block;margin:0;margin-top:20px">
                                <el-progress :text-inside="true" :show-text="false" color="#5AD8A6" stroke-linecap="butt" :stroke-width="20" :percentage="completedProgress"></el-progress>
                        </p>
                        <span style="color:#FF9901;float: right;margin:0;margin-top:20px">{{completed}}次</span>
                    </el-col>
                    <el-col :span="8" style="">

                            <div id="coverEchart" style="width:100%;height: 150px;"></div>


                    </el-col>
                </el-col>
                <el-col :span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto"></div>
                </el-col>
                <el-col :span="12" style="margin-top:-35px;">
                        <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
                    <div>
                        <div id="main1" style="width:100%;height: 300px;"></div>
                    </div>

                </el-col>
            </el-row>
            <el-row v-else>
                <el-col :span="11" >
                        <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->

                        <div id="subordinates" style="width:100%;height: 300px;"></div>


                </el-col>
                <el-col :span="1" style="border: 1px transparent solid;">
                    <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 100px auto"></div>
                </el-col>
                <el-col :span="12" >

                        <div id="main2" style="width:100%;height: 300px;"></div>
                        <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->

                </el-col>
            </el-row>


            <el-row>
                <el-col :span="12" v-if="!isManager">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">协访次数</p>
                </el-col>
                <el-col :span="12" v-else>
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">协访下属情况</p>
                </el-col>
                <el-col :span="12">
                    <p style="font-size: 18px;color: #4A90E2;text-align: center">协访反馈对比</p>
                </el-col>
            </el-row>
            <el-row v-if="!isManager">
                <el-col>
                    <el-table
                            :data="terminalArray"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="territory_name"
                                label="辖区"
                                sortable
                                >
                        </el-table-column>
                        <el-table-column
                                prop="plans"
                                sortable
                                label="计划协访数">
                        </el-table-column>
                        <el-table-column
                                prop="completed"
                                sortable
                                label="完成协访数">
                        </el-table-column>
                        <el-table-column
                                prop="planned"
                                sortable
                                label="完成数(计划内)">
                        </el-table-column>
                        <el-table-column
                                prop="planing"
                                sortable
                                label="完成数(计划外)">
                        </el-table-column>
                        <el-table-column
                                prop="forms"
                                sortable
                                label="完成协访评估表"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                prop="clients"
                                sortable
                                label="协访客户数">
                        </el-table-column>
                        <el-table-column
                                prop="in_field"
                                sortable
                                label="协访时长">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row v-else>
                <el-col>
                    <el-table
                            :data="terminalArray"
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                sortable
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="territory_name"
                                label="下级辖区"
                                sortable
                                >
                            <template slot-scope="scope">
                                {{scope.row.territory_name}}{{scope.row.staff_name?'('+scope.row.staff_name+')':''}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="plan"
                                sortable
                                label="计划协访数">
                            <template slot-scope="scope">
                                {{scope.row.plan||0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="completed"
                                sortable
                                label="完成协访数">
                            <template slot-scope="scope">
                                {{scope.row.completed||0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="planned"
                                sortable
                                label="完成数(计划内)">
                            <template slot-scope="scope">
                                {{scope.row.planned||0}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                sortable
                                label="完成数(计划外)">
                            <template slot-scope="scope">
                                {{Number(scope.row.completed)-Number(scope.row.planned)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="forms"
                                sortable
                                label="完成协访评估表"
                                width="150">
                            <template slot-scope="scope">
                                {{(scope.row.forms||0)+'份'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="clients"
                                sortable
                                label="协访客户数">
                            <template slot-scope="scope">
                                {{(scope.row.clients||0)+'家'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="in_field"
                                sortable
                                label="协访时长">
                            <template slot-scope="scope">
                                {{scope.row.in_field?(scope.row.in_field/60).toFixed(1):0+'小时'}}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row style="margin-top:20px;">
                <el-col style="font-size: 12px;color: #87909A;margin: 5px 0">
                    * 协访客户数为协访人和被协访人在协访当天都完成签到的客户统计
                </el-col>
                <el-col style="font-size: 12px;color: #87909A;">
                    ** 协访时长为协访人和被协访人在协访当天签到记录的重合时间段累计
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>

    import navBar from '../../../components/navBar'
    import reportMonth from './reportMonth'
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import moment from 'moment'
    import check from '../../../assets/images/check.png'
    import popedom from "./popedom";
    export default {
        name: "TutoringAnalysis",
        data() {
            return {
                date:'',
                // date: new Date(),
                campaignArray:[],
                campaignOptions:[],
                isManager:this.$store.getters.getUser.role !== 'staff',
                bookCategoryChart:'',
                bookCategoryChart2:'',
                subordinatesChart:'',
                coverEchart:'',
                plansProgress:0,
                completedProgress:0,
                plans:0,
                completed:0,
                assessmentForm:[],
                form_id:'',
                terminalArray:[],
                radarDate:[],
                indicatorMax:[],
                strName:'',
                activity_date:'',
                oldactivity_date:'',
                radarData:[],
                oldradarData:[],
                subordinates:[],
                planned:0,
                plansList:[],
                completedList:[],
                contrast:[],
                subordinates2:[],
                array:[],
                yearsDate:''
            }
        },
        components: {
            popedom,
            reportMonth
        },
        created () {

            this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')
        },
        mounted () {
            this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')

            window.onresize = () => {
                this.bookCategoryChart.resize()
                this.coverEchart.resize()
                this.bookCategoryChart2.resize()
                this.subordinatesChart.resize()
            }

            if(!this.isManager){
                this.getVisitCoverStaffTerritory()
                // this.getAssessmentList()
            }
            this.getAssessmentList()
        },
        updated(){
        },
        methods: {
            shelfData(){
                this.getData()
            },
            handleSelectInputClick(){
                this.getData()
            },
            handleSelectInput(j){
                this.date = j
            },
            async getAssessmentList(){
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id,
                    }
                    await http.post('/wapi/v1/getAssessmentList',data).then(res=>{
                        if(res.success){
                            this.assessmentForm= res.data
                            this.form_id = res.data[0].form_id
                            this.getData()
                        }
                    })
                }  catch (e) {

                }
            },
            async getVisitCoverStaffTerritory(){
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id:user.tenant_id,
                        user_id : user.user_id,
                        month : this.GLOBAL.date,
                    }
                    await http.post('/wapi/v1/getVisitCoverStaffTerritory',data).then(res=>{
                        if(res.success){
                            this.GLOBAL.territory_id = res.data


                        }
                    })
                }  catch (e) {

                }
            },
            async getData(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        role : user.role,
                        month : this.GLOBAL.date,
                        form_id : this.form_id,
                        territory_id : this.GLOBAL.territory_id
                    }
                    await http.post('/wapi/v1/getTutoringHelpAnalysis',data).then(res=>{

                        if(res.success){
                            // this.subordinates = []
                            // this.plansList = []
                            // this.completedList = []
                            // this.planned = 0
                            // this.subordinates = []
                            //
                            // this.plans = 0
                            // this.completed = 0
                            //
                            // this.terminalArray = res.data.terminalArray
                            // this.terminalArray.forEach(item=>{
                            //     item.forms = Number(item.forms) + '份'
                            //     item.clients = Number(item.clients) + '家'
                            //     if(Number(item.in_field)>0){
                            //         item.in_field = (Number(item.in_field)/60).toFixed(2) + '小时'
                            //     }else{
                            //         item.in_field = 0 + '小时'
                            //     }
                            //     if(item.alias){
                            //         item.territory_name = item.territory_name +'('+item.alias+')'
                            //     }else{
                            //         item.territory_name = item.territory_name
                            //     }
                            //
                            //     item.planing = Number(item.completed) - Number(item.planned) ? Number(item.completed) - Number(item.planned) : 0
                            //     this.planned += Number(item.planned)
                            //     this.subordinates.push(item.alias)
                            //     this.subordinates = Array.from(new Set(this.subordinates))
                            //     this.plansList.push(Number(item.plans))
                            //     this.completedList.push(Number(item.completed))
                            // })
                            // this.plansProgress = 0
                            // this.completedProgress = 0
                            // if(!this.isManager){
                            //     if(this.terminalArray.length>0){
                            //         this.plans = Number(res.data.terminalArray[0].plans)
                            //         this.completed = Number(res.data.terminalArray[0].completed)
                            //         if(this.plans>0){
                            //             this.plansProgress = 100
                            //             this.completedProgress = this.completed/this.plans*100
                            //         }else{
                            //             this.plansProgress = 0
                            //         }
                            //     }
                            //     this.oldactivity_date = ''
                            //     this.activity_date = ''
                            // if(res.data.terArray.length>0){
                            //     this.activity_date = res.data.terArray[0].activity_date
                            // }
                            // if(res.data.oldterArray.length>0){
                            //     this.oldactivity_date = res.data.oldterArray[0].activity_date
                            // }
                            //
                            //
                            //     this.radarDate = [this.oldactivity_date,this.activity_date]
                            //     let obj ={}
                            //     this.radarData = []
                            //     this.oldradarData = []
                            //     this.indicatorMax = []
                            //     for(let i = 0;i<res.data.category_array.length;i++){
                            //         if(Number(res.data.category_array[i].items) > Number(res.data.oldcategory_array[i].items)){
                            //             obj = {
                            //                 name : res.data.category_array[i].name,
                            //                 max : Number(res.data.category_array[i].items)*10
                            //             }
                            //         }else{
                            //             obj = {
                            //                 name : res.data.category_array[i].name,
                            //                 max : Number(res.data.oldcategory_array[i].items)*10
                            //             }
                            //         }
                            //         this.indicatorMax.push(obj)
                            //
                            //         this.radarData.push(res.data.category_array[i].subtotal_score)
                            //         this.oldradarData.push(res.data.oldcategory_array[i].subtotal_score)
                            //
                            //
                            //     }
                            // }else{
                            //
                            //     let obj = {}
                            //     this.indicatorMax = []
                            //
                            //     if(res.data.subordinatesArray.length>0){
                            //         let subArray = res.data.subordinatesArray[0]
                            //         for(let i =0;i<subArray.length;i++){
                            //             obj = {
                            //                 name : subArray[i].name,
                            //                 max : Number(subArray[i].items)*10
                            //             }
                            //             this.indicatorMax.push(obj)
                            //         }
                            //     }
                            //
                            //
                            //
                            //     let arr1 =[]
                            //
                            //     for(let k =0;k<res.data.subordinatesArray.length;k++){
                            //         let arr =[]
                            //         for(let j = 0 ; j<res.data.subordinatesArray[k].length;j++){
                            //             let asd = Number(res.data.subordinatesArray[k][j].subtotal_score)
                            //             arr.push(asd)
                            //         }
                            //         arr1.push(arr)
                            //     }
                            //     let obj1={}
                            //     this.contrast = []
                            //     for(let i =0;i<res.data.nameArray.length;i++){
                            //
                            //         this.subordinates2.push(res.data.nameArray[i])
                            //         obj1={
                            //             value:arr1[i],
                            //             name:res.data.nameArray[i]
                            //         }
                            //         this.contrast.push(obj1)
                            //
                            //     }
                            //     console.log(this.indicatorMax,this.contrast)
                            //
                            // }
                            this.subordinates = []
                            this.plansList = []
                            this.completedList = []
                            this.indicatorMax = []
                            this.contrast = []
                            const array = res.data.array||[]
                            const categoryArray = res.data.categoryArray||[]
                            const defaultValue = []
                            this.terminalArray = array
                            categoryArray.forEach(item=>{
                                this.indicatorMax.push({
                                    name:item.category_title,
                                    max:50
                                })
                                defaultValue.push(0)
                            })
                            array.forEach(item=>{
                                this.subordinates.push(item.territory_name)
                                this.plansList.push(Number(item.plan))
                                this.completedList.push(Number(item.completed))
                                let valArray = defaultValue
                                if(item.formScore.length>0) valArray =[]
                                item.formScore.forEach(item1=>{
                                    valArray.push(item1.score)
                                })
                                this.contrast.push({
                                    name:item.territory_name,
                                    value:valArray
                                })
                            })
                            this.init()
                        }

                        loading.close()
                    })
                }  catch (e) {
                    loading.close()
                }
            },
            init(){

                if(!this.isManager){

                    var bookOption = {}
                    var coverOption = {}

                    this.bookCategoryChart =this.$echarts.init(document.getElementById('main1'));
                    this.coverEchart=this.$echarts.init(document.getElementById('coverEchart'));

                    this.bookCategoryChart.clear()
                    this.coverEchart.clear()

                    bookOption = {
                        tooltip: {},
                        legend: {
                            data: this.radarDate,
                            bottom: '0',
                        },
                        radar: {
                            // shape: 'circle',
                            name: {
                                textStyle: {
                                    color: '#fff',
                                    backgroundColor: '#999',
                                    borderRadius: 3,
                                    padding: [3, 5]
                                }
                            },
                            indicator: this.indicatorMax
                        },
                        series: [{
                            name: '',
                            type: 'radar',
                            // areaStyle: {normal: {}},
                            data: [
                                {
                                    value: this.radarData,
                                    name: this.activity_date
                                },
                                {
                                    value: this.oldradarData,
                                    name: this.oldactivity_date
                                }
                            ]
                        }]
                    }
                    coverOption = {
                        color:['#419DE7', '#d9ebfa'],
                        title:{
                            text:'计划达成率',
                            textStyle: {
                                color:'#909399',
                                fontWeight: 100,
                                fontSize: 14
                            },
                            x:'center',
                            y:'bottom'
                        },
                        series: [
                            {
                                type: 'pie',
                                center: ['50%', '40%'],
                                radius: ['70%', '80%'],
                                avoidLabelOverlap: false,
                                hoverAnimation: false,
                                label: {
                                    normal: {
                                        show: true,
                                        position: 'center',
                                        formatter: '{w|{d}}{t|%}',
                                        rich:{
                                            w:{
                                                fontSize:21,
                                                fontWeight:'bold'
                                            },
                                            t:{
                                                fontSize:14,

                                            }
                                        }
                                    }
                                },
                                labelLine: {
                                    normal: {
                                        show: false
                                    }
                                },

                                data:[
                                    {
                                        value: this.completed,
                                    },
                                    {
                                        value: this.plans - this.completed,
                                        label: {
                                            normal: {
                                                show: false
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }

                    this.bookCategoryChart.setOption(bookOption,true)
                    this.coverEchart.setOption(coverOption,true)


                }else{

                    var subordinatesOption = {}
                    var bookCategoryOption = {}

                    this.subordinatesChart =this.$echarts.init(document.getElementById('subordinates'));
                    this.bookCategoryChart2 =this.$echarts.init(document.getElementById('main2'));

                    this.subordinatesChart.clear()
                    this.bookCategoryChart2.clear()

                    subordinatesOption = {
                        tooltip: {
                            trigger: 'axis',
                            // formatter: function (data) {
                            //     let str = data[0].axisValue + "</br>"
                            //     data.forEach(item=>{
                            //         str = str +item.marker+ item.seriesName + " : " + item.data + "</br>"
                            //     })
                            //     return str
                            // }
                        },
                        xAxis: [
                            {
                                type: 'category',
                                data: this.subordinates,
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine:{					//---坐标轴 轴线
                                    show:true,					//---是否显示

                                    //------------------- 箭头 -------------------------
                                    symbol:['none', 'none'],	//---是否显示轴线箭头
                                    symbolSize:[8, 8] ,			//---箭头大小
                                    symbolOffset:[0,7],			//---箭头位置

                                    //------------------- 线 -------------------------
                                    lineStyle:{
                                        color:'#9D9D9D',
                                        width:1,
                                        type:'solid',
                                    },
                                },
                                axisTick:{					//---坐标轴 刻度
                                    show:false,					//---是否显示
                                    inside:true,				//---是否朝内
                                    lengt:5,					//---长度
                                    lineStyle:{
                                        //color:'red',			//---默认取轴线的颜色
                                        width:1,
                                        type:'solid',
                                    },
                                },
                                axisLabel:{					//---坐标轴 标签
                                    show:true,					//---是否显示
                                    inside:false,				//---是否朝内
                                    rotate:0,					//---旋转角度
                                    margin: 5,					//---刻度标签与轴线之间的距离
                                    //color:'red',				//---默认取轴线的颜色
                                },
                                splitLine:{					//---grid 区域中的分隔线
                                    show:false,					//---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
                                    lineStyle:{
                                        color:'#9D9D9D',
                                        width:1,
                                        type:'solid',
                                    },
                                },
                            }

                        ],
                        yAxis: {show:false},
                        series: [
                            {
                                name: '计划协访数',
                                type: 'bar',
                                data: this.plansList,
                                itemStyle:{
                                    color:"#5B8FF9",
                                    background:"#F4F7F7"
                                }
                            },
                            {
                                name: '计划完成数',
                                type: 'bar',
                                data: this.completedList,
                                itemStyle:{
                                    color:"#5AD8A6",
                                    background:"#F4F7F7"
                                }
                            },

                        ]
                    }
                    bookCategoryOption = {
                        tooltip: {},
                        legend: {
                            data: this.subordinates,
                            bottom: '0',
                        },
                        radar: {
                            // shape: 'circle',
                            name: {
                                textStyle: {
                                    color: '#fff',
                                    backgroundColor: '#999',
                                    borderRadius: 3,
                                    padding: [3, 5]
                                }
                            },
                            indicator: this.indicatorMax
                        },
                        series: [{
                            name: '',
                            type: 'radar',
                            // areaStyle: {normal: {}},
                            data: this.contrast
                        }]
                    }

                    this.subordinatesChart.setOption (subordinatesOption,true);
                    this.bookCategoryChart2.setOption (bookCategoryOption,true);

                }


            },
            searchWeekList(){
                this.subordinates = []

                this.GLOBAL.date = this.date
                this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')
                this.getData()
            },
            ResetClick(){
                this.form_id =''
            },
            exportDataClick(){
                if(this.isManager){
                    this.exportClick()
                }else{
                    this.exportClickStaff()
                }
            },
            exportClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['下级辖区', '计划协访数', '完成协访数', '完成数(计划内)', '完成数(计划外)','完成协访评估表','协访客户数','协访时长']
                        const filterVal = [
                            'territory_name',
                            'plan',
                            'completed',
                            'planned',
                            'planing',
                            'forms',
                            'clients',
                            'in_field',
                        ]
                        const list = JSON.parse(JSON.stringify(this.terminalArray))
                        list.forEach(item=>{
                            let str = item.staff_name ? '('+item.staff_name+')':''
                            item.territory_name = item.territory_name + str
                            item.plan = item.plan || 0
                            item.completed = item.completed || 0
                            item.planned = item.planned || 0
                            item.planing = Number(item.completed)-Number(item.planned) || 0
                            item.forms = (item.forms || 0) +'份'
                            item.clients = (item.clients || 0) +'家'
                            item.in_field = item.in_field?(item.in_field/60).toFixed(1):0+'小时'
                        })
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '辅导/协访分析',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            exportClickStaff(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['辖区', '计划协访数','完成协访数','完成数(计划内)', '完成数(计划外)','完成协访评估表','协访客户数','协访时长']
                        const filterVal = [
                            'territory_name',
                            'plans',
                            'completed',
                            'planned',
                            'planing',
                            'forms',
                            'clients',
                            'in_field',
                        ]

                        const list = this.terminalArray
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '辅导/协访分析',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportDetailClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data ={
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        role:this.$store.getters.getUser.role,
                        month:this.GLOBAL.date,
                        territory_id:this.GLOBAL.territory_id,
                    }
                    http.post('/wapi/v1/getSignDetailVisitTay',data).then(res=>{
                        if(res.success){
                            this.array = res.data
                            this.exportClick1()
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }

            },
            exportClick1(){

                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = [ '开始时间', '结束时间', '协访人', '被协访人','协访类型', '计划协访客户数', '实际协访客户数', '完成评估表份数','是否计划内协访','创建人']
                        const filterVal = [
                            'start_time',
                            'end_time',
                            'coach_name',
                            'coachee_name',
                            'coaching_type',
                            'plan_num',
                            'clients',
                            'forms',
                            'status',
                            'last_name'
                        ]

                        const list = this.array
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '辅导/协访明细',
                            autoWidth: this.autoWidth
                        })
                    })

                } catch (err) {

                    this.error()
                }
            },


        },

    }
</script>

<style scoped>
    #TutoringAnalysis {
        background: #fff;
        height: 100%;
        box-sizing: border-box;
    }
    #TutoringAnalysis >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }
    #TutoringAnalysis >>>.el-table th{
        padding: 7px 0px;
    }
    #TutoringAnalysis >>>.el-table td{
        padding: 7px 0px;
    }
    #TutoringAnalysis >>> .el-progress-bar__outer{
        border-radius: 2px;
    }
    #TutoringAnalysis >>> .el-progress-bar__inner{
        border-radius: 2px;
    }
    #TutoringAnalysis >>> .el-progress-bar__outer{
        background: #fff;
    }


</style>



// WEBPACK FOOTER //
// src/pages/statement/components/TutoringAnalysis.vue